import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-icon',
  imports: [],
  templateUrl: './service-icon.html',
  styleUrl: './service-icon.css'
})
export class ServiceIcon {
  @Input() businessTypeName: string | null = null;

  /**
   * Mapea el nombre del tipo de negocio a un icono SVG específico
   * Retorna el nombre del icono a usar o null para el icono genérico
   */
  getIconType(): string | null {
    if (!this.businessTypeName) {
      return null; // Icono genérico
    }

    const typeName = this.businessTypeName.toLowerCase();

    // Salón de belleza / Peluquería → tijeras
    if (
      typeName.includes('peluqueria') ||
      typeName.includes('salon de belleza') ||
      typeName.includes('barberia')
    ) {
      return 'scissors';
    }

    // Barbería → barber pole / tijeras
    if (typeName.includes('barberia')) {
      return 'scissors';
    }

    // Estética / Spa → cuidado personal
    if (
      typeName.includes('spa') ||
      typeName.includes('estetica') ||
      typeName.includes('centro de depilacion') ||
      typeName.includes('manicure') ||
      typeName.includes('pedicure') ||
      typeName.includes('cejas') ||
      typeName.includes('pestanas') ||
      typeName.includes('maquillaje')
    ) {
      return 'spa';
    }

    // Estudio de tatuajes → tatuaje / pluma / tinta
    if (typeName.includes('tatuajes') || typeName.includes('tattoo')) {
      return 'tattoo';
    }

    // Otros tipos → icono genérico
    return null;
  }
}
